<template>
    <header class="inner-page__header  inner-page__header-light">
        
        <div class="row  justify-content-between  align-items-center">
            
            <div class="inner-page__logo  col">
                <div class="exam__sidebar-logo">
                    <LogoComponent />
                </div>
            </div>
            <div class="inner-page__right">
                <div class="inner-page__lang test-language">
                    <button class="language-button btn btn-sm dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <span class="lang-sm lang-lbl" :title="$lang.app[currentLocale]" :lang="currentLocale"></span>
                    </button>
                    <div v-if="$store.getters['language/getLocales'].length > 0" class="dropdown-menu">
                        <a v-for="locale in $store.getters['language/getLocales']" @click="changeLocale(locale.title)" class="dropdown-item" href="javascript:void(0)">
                            <span class="lang-sm lang-lbl" :lang="locale.title"> {{$lang.app[locale.title]}}</span>
                            <span class="sr-only">{{locale.title}}</span>
                        </a>
                    </div>
                </div>
                <div class="page-header__user-block">
                    <ul class="page-header__nav-list">
                        <li class="page-header__nav-item">
                            <router-link :to="{name:'candidate.login'}" class="page-header__nav-link"  title="На главную">
                                {{ getTranslation('toHome') }}
                            </router-link>
                        </li>
                    </ul>
                
                </div>
            </div>
        
        </div>
        <!-- /row -->
    
    </header>
</template>

<script>
    import LogoComponent from "../../layouts/components/LogoComponent";
    
    export default {
        name: "AuthHeader",
        components: { LogoComponent }
    }
</script>

<style scoped>

</style>
